import { useMutation } from '@tanstack/react-query';
import { toast } from '@pella/sash-framework';
import { getOpenRequestsByActionIdAndDynamicInput } from '../../api/production-request-api/index.js';

/**
 * Hook containing the function for looking up open requests that already match an action and
 * dynamic input. Modeled as a mutation so it can be fired imperatively from a submit handler.
 */
export const useOpenRequestsCheck = () =>
  useMutation({
    /**
     * mutateFn - Function to call the getOpenRequestsByActionIdAndDynamicInput api.
     * @param {{actionId: string, dynamicInput: string}} variables - The action and dynamic input to match.
     */
    mutationFn: ({ actionId, dynamicInput }) => getOpenRequestsByActionIdAndDynamicInput(actionId, dynamicInput),
    onError: () => toast.error('Error checking for open requests.'),
  });
